<ng-container *ngIf="showBtm">
<ng-container *ngIf="redesign; else noRedesign">
<div id="hooks" class="container rt-sm pb-4 mt-3 redesign" [attr.data-qa]="'bottm-bucket-redesign'">
    <div class="toolbox pt-3 pb-3 container-color">
        <h2 [attr.data-qa]="'bottm-bucket-redesign-title'" class="mb-3">Tools and tips just for you</h2>
        <div class="row">
            <div id="engage">
                <div class="col-xs-12 col-sm-12 col-md-6 place-holder" *ngIf="!pznBottomLeft; else rbtmLeft">
                    <div class="col-xs-12 text-center">
                        <h2 class="h3">Loading...<span class="fa fa-spinner fa-spin"></span></h2>
                    </div>
                </div>
                <ng-template #rbtmLeft>
                    <div class="col-xs-12 col-sm-12 col-md-6" [attr.data-qa]="'btmLeft-redesign-div'">
                        <div class="row card-link">
                            <div class="col-xs-12">
                                <h3 [attr.data-qa]="'btmLeft-redesign-title'" class="h4 tool-title" [innerHtml]="pznBottomLeft.title"></h3>
                            </div>
                            <!-- <div class="col-sm-6 tool-image">
                                <img class="img-responsive" alt="" [src]="_genericService.frameUrl(pznBottomLeft.thumbnailImg) | safeUrl">
                            </div> 
                            <div class="col-sm-6"> -->
                            <div class="col-sm-12">
                                <div [attr.data-qa]="'btmLeft-redesign-shortDescription'" [innerHtml]="pznBottomLeft.shortDescription | safeHtml"></div>
                                <p>
                                    <a [attr.data-qa]="'btmLeft-redesign-ctaText'" [href]="_genericService.frameUrl(pznBottomLeft.articleLink) | safeUrl" target="_blank"  rel="noopener noreferrer"
                                        class="cta-link btn-bottom-hook" *ngIf="pznBottomLeft.articleLink">
                                        <span>{{pznBottomLeft.ctaText ? pznBottomLeft.ctaText : "Learn More"}}</span>
                                        <span class="sr-only"> About {{pznBottomLeft.title}} opens in a new window</span>
                                    </a>
                                </p>
                            </div>
                            <!-- <a [href]="_genericService.frameUrl(pznBottomLeft.articleLink) | safeUrl" target="_blank"  rel="noopener noreferrer"
                                *ngIf="pznBottomLeft.articleLink" aria-hidden="true" class="blocklink" tabindex="-1">{{pznBottomLeft.ctaText
                                ? pznBottomLeft.ctaText : "Learn More"}}</a> -->
                        </div>
                    </div>
                </ng-template>
                <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="pznBottomRight" [attr.data-qa]="'btmRight-redesign-div'">
                    <div class="row card-link">

                        <div class="col-xs-12">
                            <h3 [attr.data-qa]="'btmRight-redesign-title'" class="h4 tool-title" [innerHtml]="pznBottomRight.title"></h3>
                        </div>
                        <!-- <div class="col-sm-6 tool-image">
                            <img class="img-responsive" alt="" [src]="_genericService.frameUrl(pznBottomRight.thumbnailImg) | safeUrl">
                        </div>
                        <div class="col-sm-6"> -->
                        <div class="col-sm-12">
                            <div [attr.data-qa]="'btmRight-redesign-shortDescription'" [innerHtml]="pznBottomRight.shortDescription | safeHtml"></div>
                            <p>
                                <a [attr.data-qa]="'btmRight-redesign-ctaText'" [href]="_genericService.frameUrl(pznBottomRight.articleLink) | safeUrl" target="_blank"  rel="noopener noreferrer"
                                    class="cta-link btn-bottom-hook" *ngIf="pznBottomRight.articleLink">
                                    {{pznBottomRight.ctaText ? pznBottomRight.ctaText : "Learn More"}}
                                    <span class="sr-only"> About {{pznBottomRight.title}} opens in a new window</span>
                                </a>
                            </p>
                        </div>
                        <!-- <a [href]="_genericService.frameUrl(pznBottomRight.articleLink) | safeUrl" target="_blank"  rel="noopener noreferrer"
                            *ngIf="pznBottomRight.articleLink" aria-hidden="true" class="blocklink" tabindex="-1">{{pznBottomRight.ctaText
                            ? pznBottomRight.ctaText : "Learn
                            More"}}</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</ng-container>

<ng-template #noRedesign>
    <div id="hooks" class="container rt-sm pb-4 mt-3 no-redesign" [attr.data-qa]="'bottm-bucket-no-redesign'">
        <div class="col-xs-12 toolbox pt-3 pb-3 container-color">
            <div class="row">
                <div id="engage">
                    <div class="col-xs-12 col-sm-12 col-md-6 place-holder" *ngIf="!pznBottomLeft; else btmLeft">
                        <div class="col-xs-12 text-center">
                            <h2 class="h3">Loading...<span class="fa fa-spinner fa-spin"></span></h2>
                        </div>
                    </div>
                    <ng-template #btmLeft>
                        <div class="col-xs-12 col-sm-12 col-md-6" [attr.data-qa]="'btmLeft-no-redesign-div'">
                            <div class="row card-link">
                                <div class="col-xs-12">
                                    <h2 class="h4 tool-title" [attr.data-qa]="'btmLeft-no-redesign-tool-title'" [innerHtml]="pznBottomLeft.title"></h2>
                                </div>
                                <div class="col-sm-6 tool-image">
                                    <img class="img-responsive" alt="" [attr.data-qa]="'btmLeft-no-redesign-tool-image'" 
                                        [src]="_genericService.frameUrl(pznBottomLeft.thumbnailImg) | safeUrl">
                                </div>
                                <div class="col-sm-6">
                                    <div [attr.data-qa]="'btmLeft-no-redesign-shortDescription'" [innerHtml]="pznBottomLeft.shortDescription | safeHtml"></div>
                                    <p>
                                        <a [attr.data-qa]="'btmLeft-no-redesign-ctaText'" [href]="_genericService.frameUrl(pznBottomLeft.articleLink) | safeUrl"
                                            target="_blank" rel="noopener noreferrer"
                                            class="btn btn-default btn-bottom-hook" *ngIf="pznBottomLeft.articleLink">
                                            <span>{{pznBottomLeft.ctaText ? pznBottomLeft.ctaText : "Learn More"}}</span>
                                            <span class="sr-only"> About {{pznBottomLeft.title}} opens in a new window</span>
                                        </a>
                                    </p>
                                </div>
                                <a [attr.data-qa]="'btmLeft-no-redesign-articleLink'" [href]="_genericService.frameUrl(pznBottomLeft.articleLink) | safeUrl" target="_blank"
                                    rel="noopener noreferrer" *ngIf="pznBottomLeft.articleLink" aria-hidden="true"
                                    class="blocklink" tabindex="-1">{{pznBottomLeft.ctaText
                                    ? pznBottomLeft.ctaText : "Learn More"}}</a>
                            </div>
                        </div>
                    </ng-template>
                    <div class="col-xs-12 col-sm-12 col-md-6" *ngIf="pznBottomRight" [attr.data-qa]="'btmRight-no-redesign-div'">
                        <div class="row card-link">
    
                            <div class="col-xs-12">
                                <h2 class="h4 tool-title" [attr.data-qa]="'btmRight-no-redesign-tool-title'" [innerHtml]="pznBottomRight.title"></h2>
                            </div>
                            <div class="col-sm-6 tool-image">
                                <img [attr.data-qa]="'btmRight-no-redesign-tool-image'" class="img-responsive" alt=""
                                    [src]="_genericService.frameUrl(pznBottomRight.thumbnailImg) | safeUrl">
                            </div>
                            <div class="col-sm-6">
                                <div [attr.data-qa]="'btmRight-no-redesign-shortDescription'" [innerHtml]="pznBottomRight.shortDescription | safeHtml"></div>
                                <p>
                                    <a [attr.data-qa]="'btmRight-no-redesign-ctaText'" [href]="_genericService.frameUrl(pznBottomRight.articleLink) | safeUrl"
                                        target="_blank" rel="noopener noreferrer" class="btn btn-default btn-bottom-hook"
                                        *ngIf="pznBottomRight.articleLink">
                                        {{pznBottomRight.ctaText ? pznBottomRight.ctaText : "Learn More"}}
                                        <span class="sr-only"> About {{pznBottomRight.title}} opens in a new window</span>
                                    </a>
                                </p>
                            </div>
                            <a [attr.data-qa]="'btmRight-no-redesign-articleLink'" [href]="_genericService.frameUrl(pznBottomRight.articleLink) | safeUrl" target="_blank"
                                rel="noopener noreferrer" *ngIf="pznBottomRight.articleLink" aria-hidden="true"
                                class="blocklink" tabindex="-1">{{pznBottomRight.ctaText
                                ? pznBottomRight.ctaText : "Learn
                                More"}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
</ng-container>